import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { SimpleFileInput, Textarea } from '@/components/Form'
import useOfferAction from '@/features/offers/hooks/useOfferAction'
import { hideReviseOfferModal, selectReviseOfferModal } from '@/stores/offers/offersSlice'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

const OfferReviseModal = () => {
  const { show, offerId, projectName } = useSelector(selectReviseOfferModal)

  const { useReviseOffer } = useOfferAction()
  
  const reviseOffer = useReviseOffer()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const methods = useForm({
    defaultValues: {
      remarks: '',
    },
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const closeModal = () => {
    methods.reset({
      remarks: '',
    })
    setIsSubmitting(false)
    dispatch(hideReviseOfferModal())
  }

  const onSubmit = async (data) => {
    setIsSubmitting(true)
    console.log(data)
    try {
      dispatch(showLoadingOverlay())
      const res = await reviseOffer.mutateAsync({ offerId, ...data })

      const newOfferId = res?._id
      if (newOfferId && newOfferId !== '') {
        window.open(`/offers/${newOfferId}`, '_blank')
      }
      closeModal()
    } catch (err) {
      console.error(err)
    } finally {
      setIsSubmitting(false)
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <Modal isOpen={show} onClose={closeModal} size="xl">
      <ModalOverlay />
      <ModalContent>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>Revise Offer: {projectName}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex direction="column" gap={3}>
                <Textarea name="remarks" label="Remarks" rows="5" isRequired={false} />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="yellow" type="submit" isDisabled={isSubmitting}>
                  Revise
                </Button>
                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default OfferReviseModal
